import client from './client';

export const getAdjustmentsPaginated = (params) =>
  client.get('/stock-adjustments', { params }).then((r) => r.data);

export const getAdjustmentsByProduct = (productUuid) =>
  client
    .get(`/stock-adjustments/by-product/${productUuid}`)
    .then((r) => r.data);

export const createAdjustment = (data) =>
  client.post('/stock-adjustments', data).then((r) => r.data);
